<template>
    <div id="ExperienceSection">
        <div class="card">
            <div class="card-body">
                <div class="d-flex align-items-center mb-4">
                    <h5 class="card-title flex-grow-1 mb-0">Experience</h5>
                    <div class="flex-shrink-0">
                        <button @click="formContext.modal = true" class="btn btn-primary" type="button">
                            Add <span class="d-none d-sm-inline">Experience</span>
                        </button>
                    </div>
                </div>
                <CommonSpinner v-if="isLoading" />
                <div v-else class="row g-4">
                    <div v-for="(data,index) in pageData.data" :key="index" class="col-lg-6">
                        <div class="card border mb-0">
                            <div class="card-body p-3">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <span class="badge bg-primary mb-2">{{ $filters.textFromSlug(data.type) }}</span>
                                        <h5 class="mb-1">{{ data.institution }}</h5>
                                        <p class="text-muted mb-1">{{ data.department }}</p>
                                        <p class="mb-1" v-if="data.courses_taught"><strong>Courses:</strong> {{ data.courses_taught }}</p>
                                        <p class="mb-1" v-if="data.level"><strong>Level:</strong> {{ data.level }}</p>
                                        <p class="mb-1" v-if="data.duration"><strong>Duration:</strong> {{ data.duration }}</p>
                                        <p class="mb-1" v-if="data.students_supervised"><strong>Students Supervised:</strong> {{ data.students_supervised }}</p>
                                        <p class="mb-0" v-if="data.responsibilities">{{ data.responsibilities }}</p>
                                    </div>

                                    <div class="dropdown dropstart no-arrow">
                                        <button class="dropdown-toggle btn btn-sm rounded-circle btn-primary" type="button" data-bs-toggle="dropdown">
                                            <i class="ri-more-2-fill"></i>
                                        </button>
                                        <ul class="dropdown-menu">
                                            <li>
                                                <button @click.prevent="openEditView(experience)" class="dropdown-item">
                                                    Edit
                                                </button>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <p v-if="!pageData.data.length">No experience added.</p>
                </div>
            </div>
        </div>

        <b-modal
            v-model="formContext.modal"
            size="lg"
            centered
            hide-footer
            title-class="fs-6"
            :title="formContext.editMode ? 'Update Experience' : 'Add Experience'"
            @hide="closeEditView()">

            <experience-form
                v-if="formContext.modal"
                :edit-mode="formContext.editMode"
                :edit-item="formContext.item"
                @closeMe="closeEditView()"
                @addedItem="addItem"
                @updatedItem="updateItem" />

        </b-modal>
    </div>
</template>

<script>
import ExperienceForm from "@/components/forms/ExperienceForm.vue";
import { commonEditViewMixin } from "@/mixins/commonEditViewMixin";
import { commonPaginationMixin } from '@/mixins/commonPaginationMixin';

export default {
    components:{
        ExperienceForm
    },
    mixins:[
        commonEditViewMixin,
        commonPaginationMixin
    ],
    data(){
        return{
            isLoading:false,
        }
    },
    methods:{
        addItem(item){
            this.pageData.data.unshift(item);
        },
        updateItem(item){
            const index = this.pageData.data.findIndex(i=>i.id==item.id);
            Object.assign(this.pageData.data[index],item);
        },
        fetchItems(){
            this.isLoading=true;
            this.$http.get("/experiences")
            .then(response=>{
                this.isLoading=false;
                if(response.data.success){
                    this.pageData = response.data.data;
                }
            });
        }
    },
    created(){
        this.fetchItems();
    }
}
</script>